import { LitElement, html, css } from 'lit'
import { customElement, state } from 'lit/decorators.js'
import { EtaChangeReviewWrapperStyles } from './eta-change-review-styles'
import { RouteMetricsComparison } from './helper'

@customElement('eta-details-table')
export class EtaDetailsTable extends LitElement {
    static styles = [
        EtaChangeReviewWrapperStyles,
        css`
            :host {
                display: block;
                width: 60%;
            }

            table.eta-table {
                width: 100%;
                border-collapse: collapse;
            }
        `
    ]

    @state()
    private metrics: RouteMetricsComparison[] = []
    render() {

        return html`
            <table class="eta-table">
                <thead>
                    <tr>
                        <th>Details</th>
                        <th>Current</th>
                        <th>New</th>
                    </tr>
                </thead>
                <tbody>
                    ${this.metrics.map(
                        metric => html`
                            <tr>
                                <td>${metric.label}</td>
                                <td>${metric.current}</td>
                                <td>${metric.new}</td>
                            </tr>
                        `
                    )}
                </tbody>
            </table>
        `
    }
}